import Drawer from "./Drawer";
import DrawerContent from "./DrawerContent/DrawerContent";
import React from 'react';
import PoliciesManager from "../util/Policies";
import _ from "lodash";
import { Container, WithTooltip, Component, PuzzleButton } from "puzzle";
import { PuzzleTooltip as TpTooltip } from "puzzle/components";
import { getUrlWithParams } from "../util/Util";

export class DrawerWindow extends Component<any, any> {
  tooltip: any;

  /**
   * @inheritDoc
   */
  componentWillMount(): void {
    let systemPolicies = _.get(this.props.initializeUserData, 'systemPolicies');
    if (systemPolicies) {
      PoliciesManager.setup(systemPolicies);
    }
  };

  /**
   * Copy link
   */
  copyUrl = () => {
    const { submissionId } = this.props.selectedRecord;
    if (submissionId) {
      let urlToCopy = getUrlWithParams(submissionId);
      this.dispatch('copy_URI', '', { urlToCopy, toasterModuleId: 'ToastNotificationsDrawerPuzzle' })
    }
  };

  /**
   * Adds taskDetails to drawer header
   */
  taskDataRender = (): JSX.Element => {
    const {
      batchName,
      phaseName,
      targetLanguage,
      taskStatus,
    } = this.props.selectedRecord;
    const taskStatusName = taskStatus.name.replace('_', ' ');
    const tooltipTitle = `${batchName} | ${targetLanguage.value} | ${phaseName} ${taskStatusName}`
    return <>
      <Container
        className={'tp-text-semibold tp-color-accent tp-font-size-md k-text-ellipsis'}
      >
        <WithTooltip
          context={this}
          title={tooltipTitle}
          htmlTag={'span'}
        >
          <span title={tooltipTitle}>
            {`${batchName} | ${targetLanguage.value} | ${phaseName}`}
          </span>
        </WithTooltip>
        <TpTooltip
          anchorElement={'target'}
          ref={(el: any) => this.tooltip = el}
          openDelay={1000}
          position="bottom"
        />
      </Container>
    </>;
  }

  render() {
    const { preselectedDrawerTab, selectedRecord, tabsMap, initializeUserData } = this.props;
    const { submissionName, submissionId, taskId } = selectedRecord;
    const copyLinkText = taskId ? 'SRL-copyLinkSupplier' : 'SRL-copyLink';
    const detachedDrawerTpl = (
      <Container displayFlex gap={4}>
        <Container htmlTag="h3" className="tp-text-semibold tp-font-size-lg k-text-ellipsis">
          {submissionId}<span aria-hidden="true"
                              className="tp-space-right-half-1 tp-space-left-half-1">|</span>{submissionName}
        </Container>
        {taskId && this.taskDataRender()}
        <PuzzleButton
          aria-label={this.translate(copyLinkText)}
          titleText={this.translate(copyLinkText)}
          fillMode="flat"
          themeColor={'primary'}
          iconClass={"tp-icon tp-share"}
          onClick={this.copyUrl}
          tooltipPosition={'right'}
          withTooltip
        />
      </Container>
    );
    return (
      <Drawer
        header={detachedDrawerTpl}
        drawerContent={
          <DrawerContent
            data={selectedRecord}
            tabsMap={tabsMap}
            preselectedDrawerTab={preselectedDrawerTab}
            detached={true}
            initializeUserData={initializeUserData}
          />
        }
      />
    );
  }
}
